/* eslint-disable */
/**
 * WARNING: THIS FILE IS AUTO-GENERATED, DO NOT EDIT IT DIRECTLY!
 */

import * as Types from './types'

import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { ListingsFacetGroupFragmentDoc } from './listings-facet-group.graphql';
import { ListingsPlaceFragmentDoc } from './listings-place.graphql';
import { BasePlaceFieldsFragmentDoc } from './base-place-fields.graphql';
import { ResidentialPropertyListingComparablesFragmentDoc } from './residential-property-listing-comparables.graphql';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import fetcher from '../../fetchers/fetcher';

export type GetListingsMetadataQueryVariables = Types.Exact<{
  input: Types.PropertyListingConnectionInput;
  inputPlaces: Types.PropertyListingConnectionInput;
  comparablesInput?: Types.PropertyListingComparablesInput;
  facetGroupNames?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']>> | Types.InputMaybe<Types.Scalars['String']>>;
  withPlaceGeoJSON?: Types.Scalars['Boolean'];
}>;


export type GetListingsMetadataQuery = { __typename?: 'Query', facetGroups?: { __typename?: 'ResidentialPropertyListingConnection', facetGroups?: Array<{ __typename?: 'FacetGroup', name: string, facets: Array<{ __typename?: 'BasicCountFacet', id?: string | null, name: string, count: number, selected: boolean } | { __typename?: 'ResidentialListingTagFacet', id?: string | null, name: string, count: number, selected: boolean }> } | null> | null } | null, placeInfo?: { __typename?: 'ResidentialPropertyListingConnection', places?: Array<{ __typename?: 'Place', type: Types.PlaceType, nameLong: string, geoJson?: string | null, id: string, slug: string, nameShort: string, region?: { __typename?: 'Place', nameAbbreviated?: string | null, id: string, slug: string, nameShort: string } | null, metroArea?: { __typename?: 'Place', id: string, slug: string, nameShort: string } | null, country?: { __typename?: 'Place', id: string, slug: string, nameShort: string } | null, city?: { __typename?: 'Place', id: string, slug: string, nameShort: string } | null } | null> | null } | null, comparables?: { __typename?: 'ResidentialPropertyListingComparablesResponse', newListingsCount?: any | null, totalListingsCount?: any | null, soldListingsCount?: any | null, salePrice?: any | null, listingPrice?: any | null, listingPriceYearAgo?: any | null } | null };


export const GetListingsMetadataDocument = /*#__PURE__*/ `
    query GetListingsMetadata($input: PropertyListingConnectionInput!, $inputPlaces: PropertyListingConnectionInput!, $comparablesInput: PropertyListingComparablesInput! = {includeAggregationValue: false}, $facetGroupNames: [String], $withPlaceGeoJSON: Boolean! = false) {
  facetGroups: residentialPropertyListingConnection(input: $input) {
    facetGroups(name: $facetGroupNames) {
      ...ListingsFacetGroup
    }
  }
  placeInfo: residentialPropertyListingConnection(input: $inputPlaces) {
    places {
      ...ListingsPlace
    }
  }
  comparables: residentialPropertyListingComparables(
    connectionInput: $input
    comparablesInput: $comparablesInput
  ) {
    ...ResidentialPropertyListingComparables
  }
}
    ${ListingsFacetGroupFragmentDoc}
${ListingsPlaceFragmentDoc}
${BasePlaceFieldsFragmentDoc}
${ResidentialPropertyListingComparablesFragmentDoc}`;
export const useGetListingsMetadataQuery = <
      TData = GetListingsMetadataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetListingsMetadataQueryVariables,
      options?: UseQueryOptions<GetListingsMetadataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetListingsMetadataQuery, TError, TData>(
      ['GetListingsMetadata', variables],
      fetcher<GetListingsMetadataQuery, GetListingsMetadataQueryVariables>(client, GetListingsMetadataDocument, variables, headers),
      options
    );